import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { useView } from '../../hooks/useView.js';
import { block } from '../../utils/block.js';
import './CalloutCard.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgWarning } from '../../static/icons/general/warning.svg.js';
import { ReactComponent as SvgInfoOutline } from '../../static/icons/action/info_outline.svg.js';

const _excluded = ["icon", "className", "title", "status", "children"];
const b = block('callout-card');
const ICON = {
  'error': /*#__PURE__*/jsx(SvgWarning, {
    "aria-hidden": true
  }),
  'info': /*#__PURE__*/jsx(SvgInfoOutline, {
    "aria-hidden": true
  }),
  'default': null
};
const CalloutCard = _ref => {
  let {
      icon,
      className = '',
      title,
      status,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const iconComponent = icon || ICON[status];
  const view = useView();
  return /*#__PURE__*/jsxs("aside", _objectSpread2(_objectSpread2({
    className: b({
      status,
      view
    }).mix(className)
  }, rest), {}, {
    children: [iconComponent && /*#__PURE__*/jsx("div", {
      className: b('icon'),
      children: iconComponent
    }), /*#__PURE__*/jsxs("article", {
      className: b('body'),
      children: [/*#__PURE__*/jsx("h1", {
        className: b('title'),
        children: title
      }), children]
    })]
  }));
};

export { CalloutCard };
